// extracted by mini-css-extract-plugin
export var brand = "_7l-8";
export var compact = "_7l-5";
export var extraSmall = "_7l-6";
export var icon = "_7l-0";
export var large = "_7l-3";
export var light = "_7l-1";
export var medium = "_7l-4";
export var outline = "_7l-a";
export var primaryDark = "_7l-9";
export var primaryLight = "_7l-7";
export var primaryModern = "_7l-b";
export var success = "_7l-2";